import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkedInSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M21.8333 0C22.5406 0 23.2189 0.280951 23.719 0.781048C24.219 1.28115 24.5 1.95942 24.5 2.66667V21.3333C24.5 22.0406 24.219 22.7189 23.719 23.219C23.2189 23.719 22.5406 24 21.8333 24H3.16667C2.45942 24 1.78115 23.719 1.28105 23.219C0.780951 22.7189 0.5 22.0406 0.5 21.3333V2.66667C0.5 1.95942 0.780951 1.28115 1.28105 0.781048C1.78115 0.280951 2.45942 0 3.16667 0H21.8333ZM21.1667 20.6667V13.6C21.1667 12.4472 20.7087 11.3416 19.8936 10.5264C19.0784 9.71128 17.9728 9.25333 16.82 9.25333C15.6867 9.25333 14.3667 9.94667 13.7267 10.9867V9.50667H10.0067V20.6667H13.7267V14.0933C13.7267 13.0667 14.5533 12.2267 15.58 12.2267C16.0751 12.2267 16.5499 12.4233 16.8999 12.7734C17.25 13.1235 17.4467 13.5983 17.4467 14.0933V20.6667H21.1667ZM5.67333 7.41333C6.26742 7.41333 6.83717 7.17733 7.25725 6.75725C7.67733 6.33717 7.91333 5.76742 7.91333 5.17333C7.91333 3.93333 6.91333 2.92 5.67333 2.92C5.07571 2.92 4.50257 3.1574 4.07999 3.57999C3.6574 4.00257 3.42 4.57571 3.42 5.17333C3.42 6.41333 4.43333 7.41333 5.67333 7.41333ZM7.52667 20.6667V9.50667H3.83333V20.6667H7.52667Z" })]
});
const ForwardRef = forwardRef(SvgLinkedInSmall);
export { ForwardRef as ReactComponent };
